import { render, staticRenderFns } from "./BoxProgress.vue?vue&type=template&id=5b4cf5c6&scoped=true&"
import script from "./BoxProgress.vue?vue&type=script&lang=js&"
export * from "./BoxProgress.vue?vue&type=script&lang=js&"
import style0 from "./BoxProgress.vue?vue&type=style&index=0&id=5b4cf5c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4cf5c6",
  null
  
)

export default component.exports